import React from 'react';
import {DataTable} from 'primereact/datatable';
import {Column} from "primereact/column";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import TitlePage from "../../../app/Title/TitlePage/TitlePageView";
import {Button} from "primereact/button";
import LinearProgress from "@material-ui/core/LinearProgress";
import Divider from "@material-ui/core/Divider";


const CaptureGuaranteesView = (props) => {

    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <div>
                <Paper elevation={5}
                       style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                    {props.messagesGrowl}
                    <Grid container spacing={1}>
                        <Grid item xs={8}>
                            <TitlePage title="Prestatario \ Captura Garantías"/>
                        </Grid>
                        <Grid item xs={4} style={{textAlign: 'right'}}>
                            <Button label="Buscar" onClick={props.getDataGuaranteePosition}/>
                        </Grid>
                        <Grid item xs={12}>
                            <Divider/>
                        </Grid>
                        <Grid item xs={12}>
                            <div style={{textAlign: 'right'}}>
                                <Button label="Contraer / Expandir Grupos" className="p-button-secondary"
                                        onClick={props.expandReduceAll}/> &nbsp;
                                <Button type="button" iconPos="left" label="Captura Posición"
                                        className="p-button-secondary"
                                        onClick={props.redirectAddPosition}/>
                            </div>
                        </Grid>
                        <Grid item xs={12}>
                            <div className="content-section implementation">
                                <DataTable
                                    value={props.dataGuaranteePosition}
                                    expandedRows={props.expandedRows}
                                    onRowToggle={props.handleToggle}
                                    rowExpansionTemplate={props.rowExpansionTemplate}
                                    resizableColumns={true}
                                    columnResizeMode={"fit"}>
                                    <Column expander={true} style={{width: '3em'}}/>
                                    <Column field="cuenta" header="Cuenta" style={{textAlign: 'left'}}
                                            sortable={true}/>
                                </DataTable>
                            </div>
                        </Grid>
                        {props.confirmationMsg}
                    </Grid>
                </Paper>
            </div>
        </React.Fragment>
    )
};

export default /*withStyles(styles)*/(CaptureGuaranteesView);
